import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import async from '@xanadu/ui-shared/components/asyncComponent';

import GlobalBannerPortal from '@xanadu/ui-shared/components/GlobalBannerPortal';

const AsyncColossus = async(() =>
  import('@xanadu/ui-shared/components/Colossus').then(module => module.default)
);

const ColossusRouteHandler = ({ location: { search, pathname } }) => {
  const searchParams = new URLSearchParams(search);
  const redirectUrl = searchParams.get('redirectUrl') || '';

  if (redirectUrl) {
    return (
      <Redirect
        from="/colossus(/*)"
        to={`/colossus${redirectUrl}`}
        component={ColossusRouteHandler}
      />
    );
  }

  return <AsyncColossus url={pathname.replace('/colossus', '')} />;
};

export default function () {
  return (
    <React.Fragment>
      <GlobalBannerPortal />
      <Route
        path="/colossus(/*)"
        component={ColossusRouteHandler}
      />
    </React.Fragment>
  );
}

ColossusRouteHandler.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
    pathname: PropTypes.string.isRequired
  }).isRequired
};
